module.exports = __webpack_public_path__ + "media/images/kids13-efa19af1583219c5b3bddeef7a24955d.jpg";